export const P = {
  bg: '#F9F2EE', card: '#FDFAF8', peach: '#EDD5CA', rose: '#C17F74',
  deep: '#8B5E57', text: '#3A2828', muted: '#9A8080', border: '#E5D4CE',
  green: '#6EA882', amber: '#C99745', red: '#B56060', white: '#FFFFFF',
};

export const inputStyle = {
  width: '100%', padding: '10px 14px', borderRadius: '10px',
  border: `1.5px solid ${P.border}`, background: P.white, color: P.text,
  fontSize: '14px', outline: 'none', fontFamily: "'Nunito', sans-serif",
};

export const labelStyle = {
  fontSize: '11px', fontWeight: 700, color: P.muted, textTransform: 'uppercase',
  letterSpacing: '0.09em', marginBottom: '6px', display: 'block',
};

export const cardStyle = {
  background: P.card, borderRadius: '14px', padding: '18px',
  border: `1px solid ${P.border}`, marginBottom: '10px',
  boxShadow: '0 2px 10px rgba(139,94,87,0.06)',
};
